
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { ProjectState } from "../../../shared";
import GlobalControls from "./global/GlobalControls";

type Props = {
  project: ProjectState
}

function LeftControls({ project }: Props) {
  const lastSelectedLayer = useSelector((state: RootState) => state.project.lastSelectedLayer);
  
  if (lastSelectedLayer !== undefined) {
    const layer = project.layers[lastSelectedLayer];
    const seekToFrame = layer?.startFrame || undefined;
    console.log('seekToFrame', seekToFrame, lastSelectedLayer);
  }

  return (
    <div style={{
      display: 'flex',
      width: '100%',
      overflow: 'scroll',
      flexDirection: 'column',
      flex: 1,
    }}>
      <GlobalControls project={project} />
    </div>
  );
}

export default LeftControls;